export const DESKTOP_PANE_HEIGHT = "calc(100vh - 3rem)";

export const ABOUT_ID = "about";

const SECTION_ABOUT_ID = "section-about";
const SECTION_EDUCATION_ID = "section-education";
const SECTION_EXPERIENCE_ID = "section-experience";
const SECTION_LEADERSHIP_ID = "section-leadership";
const SECTION_PROJECTS_ID = "section-projects";

export const SECTION_LINKS = [
  { id: SECTION_ABOUT_ID, label: "About" },
  { id: SECTION_EDUCATION_ID, label: "Education" },
  { id: SECTION_EXPERIENCE_ID, label: "Experience" },
  { id: SECTION_LEADERSHIP_ID, label: "Leadership" },
  { id: SECTION_PROJECTS_ID, label: "Projects" },
];

export {
  SECTION_ABOUT_ID,
  SECTION_EDUCATION_ID,
  SECTION_EXPERIENCE_ID,
  SECTION_LEADERSHIP_ID,
  SECTION_PROJECTS_ID,
};
